import { render, staticRenderFns } from "./kamar2.vue?vue&type=template&id=200458b8&"
import script from "./kamar2.vue?vue&type=script&lang=js&"
export * from "./kamar2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports